var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Store(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M17,18H12a1,1,0,0,1-1-1V14.25A.25.25,0,0,0,10.75,14H9.25A.25.25,0,0,0,9,14.25V17a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V10H1A1,1,0,0,1,0,9V8.47a2.012,2.012,0,0,1,.21-.89l1.51-3a1,1,0,0,1,.893-.55H17.387a1,1,0,0,1,.893.55l1.51,3a2.012,2.012,0,0,1,.21.89V9a1,1,0,0,1-1,1H18v7A1,1,0,0,1,17,18ZM8,12h4a1,1,0,0,1,1,1v3h3V10H4v6H7V13A1,1,0,0,1,8,12ZM17.5,2H2.5A.5.5,0,0,1,2,1.5V.5A.5.5,0,0,1,2.5,0h15a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,2Z",
    transform: "translate(2 3)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Store);
export default __webpack_public_path__ + "static/media/icon-24-store.87cbaae9559527600e1d1dec8fa9d9b0.svg";
export { ForwardRef as ReactComponent };